import ThumbShape from './thumbShape';

export default class ThumbPlaceholder extends ThumbShape {
  constructor (parameters) {
    super();

    this.height = 122.5;

    this.path = null;
    this.size = 300;

    this.type = 'Shape';

    this.setValues(parameters);
  }

  getItem () {
    const $container = this.getItemContainer();

    const shapeIcon = new DOMParser().parseFromString(
      '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
        '<defs><pattern id="imgpattern" x="0" y="0" width="1" height="1"><image width="330" height="330" xlink:href="https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg"/></pattern></defs>' +
        '<path fill="url(#imgpattern)" stroke="#DDD" stroke-width="4" /></svg>',
      'text/xml');

    const $svgElem = $(document.importNode(shapeIcon.documentElement, true));
    const $path = $svgElem.find('path');
    $path.attr('d', this.path);

    $container.find('a').append($svgElem);

    $svgElem.attr('width', this.width);
    $svgElem.attr('height', this.height);

    $svgElem.attr('viewBox', this.getVB().join(' '));

    $container.css('height', this.height);

    return $container;
  }

  onItemClick (item) {
    super.onItemClick(item);
    INKIVE.EditorFacade.handle('convert_to_image_box');
  }

  onItemRelease (item) {
    super.onItemRelease(item);
    INKIVE.EditorFacade.handle('convert_to_image_box');
  }
}
